import React from "react";
import { Document, Page, Text, View, StyleSheet, BlobProvider, Image as ImagePdf, Font } from '@react-pdf/renderer';
import { Button, Group } from '@mantine/core';
import { saveAs } from 'file-saver';
import { IconDownload, IconFileDescription } from '@tabler/icons-react';

import { utils, ROOT_BASE_URL, pusatCabangActive } from "../../../../utils/globalVariables";
import { numberWithComma } from "../../../../utils/globalFunctions";

import KopDocument from "./KopDocument";

import ttdPerusahaan from "../../../../assets/images/ttd_perusahaan.png";
// import signCust from "../../../../assets/images/login_page_9.jpg";

import calibriBold from "../../../../assets/fonts/calibri-bold.ttf";
import calibriRegular from "../../../../assets/fonts/calibri-regular.ttf";

const widthNo = '25px';
const widthKeluhan = '250px';

const styles = StyleSheet.create({
  flexRow: {
    display: 'flex',
    flexDirection: "row",
    flexWrap: "nowrap",
  },
  flexRowSub: {
    flexBasis: 'auto',
    flexGrow: '1',
  },

  containerJudul: {
    display: 'flex',
    flexDirection: "row",
    flexWrap: "nowrap",
    borderBottom: '1px solid #000'
  },
  no: {
    fontFamily: 'calibri-bold',
    textAlign: 'center',
    padding: '4px',
    borderRight: '1px solid #000',
    width: widthNo
  },
  itemJasa: {
    fontFamily: 'calibri-bold',
    textAlign: 'center',
    paddingTop: '4px',
    paddingBottom: '4px',
    borderRight: '1px solid #000',
    flexBasis: 'auto',
    flexGrow: 1,
    flex: 1
  },
  keluhan: {
    fontFamily: 'calibri-bold',
    textAlign: 'center',
    paddingTop: '4px',
    paddingBottom: '4px',
    width: widthKeluhan
  },

  containerSectionA: {
    display: 'flex',
    flexDirection: "row",
    flexWrap: "nowrap",
    marginBottom: '2px',
    fontSize: '11px'
  },
  containerSectionB: {
    display: 'flex',
    flexDirection: "row",
    flexWrap: "nowrap",
    // marginBottom: '3px',
    fontSize: '11px'
  },
});

Font.register({ family: 'calibri-bold', src: calibriBold });
Font.register({ family: 'calibri-regular', src: calibriRegular });

const Points = ({ stateDesc = '', stateIsBold = false }) => {
  return (
    <View style={{ marginTop: '1px' }}>
      <View style={styles.flexRow}>
        <View style={{ width: '4px', marginRight: '2px' }}>
          <Text style={{ fontSize: '10px' }}>-</Text>
        </View>

        <View style={styles.flexRowSub}>
          <Text
            style={{
              fontSize: '10px',
              fontFamily: stateIsBold ? 'calibri-bold' : 'calibri-regular'
            }}
          >
            {stateDesc}
          </Text>
        </View>
      </View>
    </View>
  )
}

const handleUangMuka = (statePrmDP) => {
  try {
    if (!statePrmDP || String(statePrmDP) === '0') {
      return ' - ';
    } else {
      return 'Rp ' + numberWithComma(statePrmDP);
    }
  } catch (error) {
    return ' - ';
  }
}

const handleMetodeUangMuka = (prmMetode) => {
  try {
    if (!prmMetode) {
      return '';
    } else {
      let hasil = '';

      Object.keys(utils.metodeBayar).forEach(element => {
        if (element === prmMetode) {
          hasil = '(' + utils.metodeBayar[element].caption + ')';
          return
        }
      });

      return hasil;
    }
  } catch (error) {
    return '';
  }
}

const SignBlock = ({ stateKet, stateImageSrc = undefined, stateName, stateWidth, stateHeight }) => {
  return (
    <View
      style={{
        flexBasis: 'auto',
        flexGrow: '1',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative'
      }}
    >
      <View
        style={{ marginBottom: '50px' }}
      >
        <Text>
          {stateKet}
        </Text>
      </View>

      <View>
        <Text>
          {stateName}
        </Text>
      </View>

      {stateImageSrc &&
        <View
          style={{
            position: 'absolute',
            top: '15px',
            right: 0,
            left: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <ImagePdf src={stateImageSrc} style={{ width: stateWidth, height: stateHeight }} />
        </View>
      }
    </View>
  )
}

const TandaTerima = ({
  stateDataProject,
  stateCaption,
  stateProjectId,
  stateCustomerName,
  stateCustomerContact,
  stateTanggalNota,
  stateDP,
  stateDPMetode,
  stateSign,
  stateCustomerSignatureName,
  stateBarangKelengkapan,
  stateLoading,
  fnSetIdleData,
  fnGetData
}) => {

  const DocPdf = (
    <Document>
      <Page
        orientation='landscape'
        size="A5"
        // size={[595.28, 419.53]}
        // size={[140, 210]}

        style={{
          padding: '18px 24px 18px 24px',
          fontSize: '11px',
          fontFamily: 'calibri-regular'
        }}
      >
        <KopDocument
          stateCaption='TANDA TERIMA'
          stateCustomerContact={stateCustomerContact}
          stateCustomerName={stateCustomerName}
          stateProjectId={stateProjectId}
          stateTanggalNota={stateTanggalNota}
        />

        <View style={{ borderLeft: '1px solid #000', borderRight: '1px solid #000', borderBottom: '1px solid #000', marginTop: '6px' }}>
          <View fixed style={[styles.containerJudul, { borderTop: '1px solid #000', }]}>
            <Text style={styles.no}>
              No
            </Text>

            <Text style={styles.itemJasa}>
              Item/Jasa
            </Text>

            <Text style={styles.keluhan}>
              Keluhan/Kerusakan
            </Text>
          </View>

          {Array.isArray(stateDataProject) && (stateDataProject.length > 0) ? Object.keys(stateDataProject).map((keyDT, indexDT) => {
            return (
              <View
                key={keyDT}
                style={{ display: 'flex', flexDirection: "row", flexWrap: "nowrap" }}
              >
                <Text style={{ width: widthNo, borderRight: '1px solid #000', paddingLeft: '4px', paddingRight: '4px', paddingTop: '3px', paddingBottom: '1px' }}>
                  {Number(indexDT) + 1}
                </Text>

                <Text style={{ flexBasis: 'auto', flexGrow: '1', flex: 1, borderRight: '1px solid #000', paddingLeft: '4px', paddingRight: '4px', paddingTop: '3px', paddingBottom: '1px' }}>
                  {String(stateDataProject[keyDT].barang_nama).split('')}
                </Text>

                <Text style={{ width: widthKeluhan, textAlign: 'left', paddingLeft: '4px', paddingRight: '4px', paddingTop: '3px', paddingBottom: '1px' }}>
                  {stateDataProject[keyDT].barang_keluhan}
                </Text>
              </View>
            )
          })
            :
            <View
              style={{ display: 'flex', flexDirection: "row", flexWrap: "nowrap" }}
            >
              <Text style={{ width: widthNo, borderRight: '1px solid #000', padding: '4px' }}>
                -
              </Text>

              <Text style={{ flexBasis: 'auto', flexGrow: '1', flex: 1, borderRight: '1px solid #000', padding: '4px' }}>
                -
              </Text>

              <Text style={{ width: widthKeluhan, textAlign: 'left', padding: '4px' }}>
                -
              </Text>
            </View>
          }
        </View>

        {/* batas */}

        <View style={{ marginTop: '8px' }}>
          <View style={styles.containerSectionA}>
            <Text style={{ marginRight: '8px', width: '120px' }}>
              Kelengkapan Barang
            </Text>

            <Text style={{ flexBasis: 'auto', flexGrow: '1' }}>
              : {Array.isArray(stateBarangKelengkapan) && (stateBarangKelengkapan.length > 0) ?
                Object.keys(stateBarangKelengkapan).map((keyDL) => {
                  return (
                    <Text key={keyDL + 'dl_78'}>
                      <Text>{stateBarangKelengkapan[keyDL].kelengkapan_barang_nama}</Text>
                      <Text>
                        {stateBarangKelengkapan.length === (Number(keyDL) + 1) ? '' : ', '}
                      </Text>
                    </Text>
                  )
                })
                :
                <Text>Tidak ada</Text>
              }
            </Text>
          </View>

          <View style={styles.containerSectionB}>
            <Text style={{ marginRight: '8px', width: '120px' }}>
              Uang Muka
            </Text>

            <Text style={{ flexBasis: 'auto', flexGrow: '1' }}>
              : {handleUangMuka(stateDP)} {' '} {handleMetodeUangMuka(stateDPMetode)}
            </Text>
          </View>
        </View>

        {/* batas */}

        <View
          wrap={false}
          style={{ marginTop: '8px' }}
        >
          <Text style={{ fontFamily: 'calibri-bold' }}>
            Catatan:
          </Text>

          <Points
            stateDesc={pusatCabangActive.rules.one}
          />

          <Points
            stateDesc={pusatCabangActive.rules.two}
          />

          <Points
            stateDesc={pusatCabangActive.rules.three}
          />

          <Points
            stateDesc={pusatCabangActive.rules.five}
          />

          <Points
            stateDesc={pusatCabangActive.rules.six}
            stateIsBold={true}
          />
        </View>

        <View
          style={{
            flexBasis: 'auto',
            display: 'flex',
            flexDirection: "row",
            justifyContent: 'flex-end',
            flexWrap: "nowrap",
          }}
        >
          <View
            style={{
              flexBasis: 'auto',
              display: 'flex',
              flexDirection: "row",
              flexWrap: "nowrap",

              width: '45%',
              maxWidth: '45%'
            }}
          >
            <SignBlock
              stateKet='Menyerahkan,'
              stateName={stateCustomerSignatureName}
              stateImageSrc={stateSign ? `${ROOT_BASE_URL}${stateSign}` : null}
              stateWidth='auto'
              stateHeight='50px'
            />

            <SignBlock
              stateKet='Menerima,'
              stateName='Lumos'
              stateImageSrc={ttdPerusahaan}
              stateWidth='80px'
              stateHeight='auto'
            />
          </View>
        </View>
      </Page>
    </Document>
  )

  const ButtonView = ({ stateDisabled, stateCaption, stateClassName, fnClick }) => {
    return (
      <Button
        variant='filled'
        size='xs'
        disabled={stateDisabled}
        onClick={fnClick}
        className={stateClassName}

        sx={(tema) => ({
          '&[data-disabled="true"]': {
            backgroundColor: tema.colors.blue[3],
            color: '#fff',
            opacity: 0.75,
          }
        })}

        styles={{
          label: {
            textTransform: 'uppercase'
          },
        }}
      >
        {stateCaption}
      </Button>
    )
  }

  return (
    <div>
      {Array.isArray(stateDataProject) && (stateDataProject.length > 0) ?
        <BlobProvider document={DocPdf}>
          {({ url }) => {
            if (!url) {
              return <ButtonView
                stateDisabled={true}
                stateCaption='Loading..'
                stateClassName='cursorProgress'
                fnClick={() => { }}
              />
            } else {
              return <Group spacing='xs' noWrap>
                <Button
                  variant='filled'
                  size='xs'
                  mr='sm'
                  leftIcon={<IconDownload size='1rem' />}
                  onClick={() => {
                    saveAs(url, `${stateCaption} ${Array.isArray(stateDataProject) && (stateDataProject.length > 0) ? stateDataProject[0].project_id : 'DOCUMENT'}.pdf`);
                    fnSetIdleData();
                  }}
                >
                  Simpan
                </Button>

                <Button
                  variant='filled'
                  size='xs'
                  color="green"
                  px='xl'
                  leftIcon={<IconFileDescription size='1rem' />}
                  onClick={() => {
                    window.open(url);
                    fnSetIdleData();
                  }}
                >
                  Lihat
                </Button>
              </Group>
            }
          }}
        </BlobProvider>
        :
        <ButtonView
          stateDisabled={stateLoading}
          stateCaption={stateLoading ? 'Loading..' : `Generate ${stateCaption}`}
          stateClassName={stateLoading ? 'cursorProgress' : ''}
          fnClick={() => {
            fnGetData()
          }}
        />
      }
    </div>
  )
}

export default TandaTerima;